/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import { toast } from "react-toastify"
import "whatwg-fetch"

import "./src/assets/styles/index.scss"
import "./src/assets/styles/vendor.scss"

toast.configure({
  autoClose: 3000,
  hideProgressBar: true,
  position: toast.POSITION.BOTTOM_CENTER,
})
